<script setup lang="ts">
import { useCopyToClipboard } from '@/composables/useCopyToClipboard';

const props = defineProps<{
  /** Text placed on the clipboard. */
  text: string;
  /** Describes what is being copied, e.g. "room code". */
  subject: string;
}>();

const { copied, copy } = useCopyToClipboard(`Copy ${props.subject}:`);
</script>

<template>
  <button
    class="copy-icon-button"
    type="button"
    :aria-label="copied ? `${subject} copied` : `Copy ${subject}`"
    @click="copy(text)"
  >
    <UIcon
      :name="copied ? 'i-lucide-check' : 'i-lucide-copy'"
      class="text-base"
    />
  </button>
</template>

<style scoped>
.copy-icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  color: var(--color-text-secondary);
  transition: background-color 0.15s, color 0.15s;
}

.copy-icon-button:hover {
  background-color: var(--color-surface-hover);
  color: var(--color-text-primary);
}

.copy-icon-button:active {
  transform: scale(0.96);
}
</style>
